// extracted by mini-css-extract-plugin
export default {"list":"PictureList_list__qhL3p"};